import { render, staticRenderFns } from "./VAppLayout.vue?vue&type=template&id=661cdef6&scoped=true&"
import script from "./VAppLayout.vue?vue&type=script&lang=js&"
export * from "./VAppLayout.vue?vue&type=script&lang=js&"
import style0 from "./VAppLayout.vue?vue&type=style&index=0&id=661cdef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661cdef6",
  null
  
)

export default component.exports